// extracted by css-extract-rspack-plugin
export default {"productDescription":"n3OUqlWZAEv5ARgt","itemDetails":"FDt4sKgvizoaaOzB"};